
import React from "react"
import { useDispatch } from "react-redux"
import dayjs from "dayjs"
import { Button, Box, Stack, styled } from "@mui/material"
import GenericHeaderReturnButton from "../../../components/GenericHeaderReturnButton"
import PackagingExecutionHeader from "../PackagingExecutionHeader"
import PackagingExecutionResume from "../packagingExecutionToValidate/PackagingExecutionResume"
import { showPackagingExecutionRead, validatePackagingExecutionRealWaste } from "../../../actions/PackagingExecution/packagingExecution"
import { getFitCornerTag } from "../../../utils/productTagsUtils"
import PEStepper from "../PEStepper"
import PEBlockHead from "../packagingExecutionTodo/PEBlockHead"
import PESectionsWasteForm, { PESectionsWasteFormId } from "./PESectionsWasteForm"
import PackagingExecutionFooter from "../PackagingExecutionFooter"

const StyledBlock = styled("div")({
	padding: 24,
})

const PackagingExecutionWasteToWeight = ({ packagingExecution, selectedSite, selectedDate, hasSubStatus }) => {
	const dispatch = useDispatch()

	const handleSubmitPEForm = (values) => {
		dispatch(validatePackagingExecutionRealWaste(packagingExecution.objectId, values.sections))
	}

	const goToPackagingExecutionRead = () => {
		dispatch(showPackagingExecutionRead(selectedSite.objectId, selectedDate))
	}

	return (
		<>
			<PackagingExecutionHeader
				leftAction={<GenericHeaderReturnButton handleClick={goToPackagingExecutionRead} />}
				subtitle={`${selectedSite.name} - ${dayjs(selectedDate).format("DD/MM/YYYY")}`}
				fixedHeader
			/>
			<Box sx={{ marginTop: "65px" }}>
				<Stack spacing={1}>
					<StyledBlock>
						<PackagingExecutionResume
							recipeLabel={packagingExecution.recipeName}
							status={packagingExecution.status}
							packagingLine={packagingExecution.packagingLine?.name}
							expectedPackagingNumber={packagingExecution.expectedPackagingNumber}
							uniqueCode={packagingExecution.uniqueCode}
							hasSubStatus={hasSubStatus}
							fitCornerTag={getFitCornerTag(packagingExecution.recipe)}
						/>
					</StyledBlock>
					<PEStepper
						withTitle={false}
						packagings={packagingExecution.packagings}
						status={packagingExecution.status}
						times={{
							theoreticalStartTime: packagingExecution.theoreticalStartTime,
							theoreticalEndTime: packagingExecution.theoreticalEndTime,
							startTime: packagingExecution.startTime,
							endTime: packagingExecution.endTime
						}}
					/>
					<StyledBlock sx={{ marginTop: "16px !important" }}>
						<Stack spacing={3}>
							<PEBlockHead
								icon="recycle"
								title="Restes"
								description="Pesez et saisissez les quantités qui n’ont pas été barquettées."
							/>
							<PESectionsWasteForm
								sections={packagingExecution.sections}
								handleSubmit={handleSubmitPEForm}
							/>
						</Stack>
					</StyledBlock>
				</Stack>
			</Box>
			<PackagingExecutionFooter
				className="center"
				fixed
				rightAction={
					<Button
						type="submit"
						form={PESectionsWasteFormId}
						variant="contained"
					>
						Terminer
					</Button>
				}
			/>
		</>
	)

}

export default PackagingExecutionWasteToWeight